<template>
  <div>
    <img alt="tag" class="tag-img" :src="imgSrc">
    <p class="tag-text">{{text}}</p>
  </div>
</template>

<script>
  export default {
    props: {
      text: String,
      imgSrc: String
    }
  }
</script>